module.exports = __webpack_public_path__ + "files/56aa9100b004ad0e13417fb2b8da58f8.png";